document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Data (All 6 Items)
  const ingredients = [
    {
      name: "BIO-MIMETIC KERATIN   ",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Bio-Mimetic_Keratin_Single_aa6aa7c6-242c-4463-868c-63079c9f3170.webp?v=1768496298",
      desc: "A smart protein that mimics your hair’s natural structure. It seeks out damaged bonds and fills the gaps, instantly reinforcing weak strands against breakage."
    },
        {
      name: "HIMALAYAN JATAMANSI",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Himalayan_Jatamansi_Single.webp?v=1768492708",
      desc: "The 'Crown Jewel' of Ayurveda. A rare, high-altitude root prized for centuries for its ability to darken hair pigment and extend the active growth phase of the hair cycle."
    },
    {
      name: "LIPO-DRIVE™ TECHNOLOGY",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Lipo-Drive_Technology_single.webp?v=1768492708",
      desc: "Our advanced delivery system encapsulates active ingredients in microscopic spheres, helping them bypass the surface to target the hair root directly."
    },
    {
      name: "ROSEMARY CONCENTRATE",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Rosemary_Concentrate_Single.webp?v=1768492708",
      desc: " Nature’s most potent growth activator. This high-performance extract stimulates micro-circulation in the scalp, waking up dormant follicles for visibly thicker density."
    },
    {
      name: "VOLUMIZING RICE PEPTIDES",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Volumizing_Rice_Peptides_Single.webp?v=1768492708",
      desc: "Inspired by the ancient Yao women’s tradition. These plant-based peptides expand the hair shaft to create instant volume and bounce, while smoothing the cuticle for a glass-like shine."
    },
    {
      name: "ABYSSINIAN PHYTO-LIPIDS",
      image: "https://cdn.shopify.com/s/files/1/0947/3769/5039/files/Abyssinian_Phyto-Lipids_Single.webp?v=1768492708",
      desc: "Rich in long-chain fatty acids, these rare plant lipids fill the microscopic gaps in the cuticle, creating a smooth, reflective surface that repels humidity."
    }
  ];

  const DURATION = 5000; // 5 seconds per slide
  const container = document.getElementById('ingredients-btn-container');
  const textEl = document.getElementById('ing-text');
  const imgEl = document.getElementById('ing-image');
  
  let currentIndex = 0;
  let timer;

  // 2. Create Buttons
  ingredients.forEach((ing, index) => {
    const btn = document.createElement('button');
    btn.className = 'ing-btn';
    btn.textContent = ing.name;
    btn.addEventListener('click', () => manualSwitch(index));
    container.appendChild(btn);
  });

  const buttons = document.querySelectorAll('.ing-btn');

  // 3. Update Function
  function updateSlide(index) {
    buttons.forEach(b => b.classList.remove('active'));
    
    // Small timeout for CSS transition reset
    setTimeout(() => {
        buttons[index].classList.add('active');
    }, 50);

    const data = ingredients[index];
    
    // Crossfade effect
    textEl.style.opacity = 0;
    imgEl.style.opacity = 0.8;
    
    setTimeout(() => {
      textEl.textContent = data.desc;
      imgEl.src = data.image;
      textEl.style.opacity = 1;
      imgEl.style.opacity = 1;
    }, 200);

    // Auto-advance
    clearTimeout(timer);
    timer = setTimeout(() => {
      let nextIndex = (index + 1) % ingredients.length;
      updateSlide(nextIndex);
    }, DURATION);
  }

  // 4. Manual Click
  function manualSwitch(index) {
    currentIndex = index;
    updateSlide(index);
  }

  // Start
  updateSlide(0);
});